import React from 'react';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import ApiService from '../../../common/services/ApiService';
import MetadataService from '../../../common/services/MetadataService';
import AdminTable from '../../../common/components/table/AdminTable';
import AdminModal from '../../../common/components/modal/AdminModal';
import EmploymentTypeForm from '../../../common/components/modal/EmploymentTypeForm';

const styles = theme => ({
  employmentTypesHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`
  }
});

class EmploymentTypes extends React.Component {

  constructor(props) {
    super(props);
    this.api = new ApiService();
    this.meta = new MetadataService();
    this.state = {
      id: null,
      mode: null,
      open: false,
      refreshTick: 0
    };
  }

  forceRefresh = () => {
    this.setState({ refreshTick: Date.now() });
  };

  handleCloseModal = () => {
    this.setState({ mode: null, open: false, id: null });
  };

  handleOpenAddModal = () => {
    this.setState({ mode: 'add', open: true, id: null });
  };

  handleOpenEditModal = (row) => {
    this.setState({ mode: 'edit', open: true, id: row.id });
  };

  render() {
    const { classes, instituteDetails } = this.props;
    const { id, mode, open } = this.state;
    const fields = ['name', 'professional_points', 'num_lj_required', 'num_vocational_lj_required', 'vocational_points', 'profiling_tool_required', 'profiling_require_supervisor_step'];
    if(instituteDetails?.vcm_enabled){
      fields.push('vcm_enabled')
    }
    const actions = ['edit', 'delete'];

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <Paper>
            <Grid
              container
              className={classes.employmentTypesHeader}
              justifyContent="space-between"
            >
              <Typography variant="h6">
                Employment Types &amp; Passport Requirements
              </Typography>
              <Button
                color="secondary"
                onClick={this.handleOpenAddModal}
                size="small"
                variant="contained"
              >
                <Typography variant="button">Add</Typography>
              </Button>
            </Grid>
            <AdminTable
              tableBottomPadding
              actionsSection={actions}
              fields={fields}
              onOpenEditModal={this.handleOpenEditModal}
              refreshTick={this.state.refreshTick}
              resource="employment_types"
            />
          </Paper>
        </Grid>
        <AdminModal
          component={EmploymentTypeForm}
          fields={fields}
          id={id}
          mode={mode}
          onCloseModal={this.handleCloseModal}
          onForceRefresh={this.forceRefresh}
          open={open}
          resource="employment_types"
          title="Employment Type"
          vcm_enabled={instituteDetails?.vcm_enabled}
        />
      </Grid>
    );
  }

}

export default withStyles(EmploymentTypes, styles, { withTheme: true });
